import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  customers: [],
  tempCustomers: [],
  isLoading: false,
  pagination: {
    total: 0,
    page: 1,
    pages: 1,
  },
};

const customerSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    setCustomers(state, action) {
      state.customers = action.payload;
      state.isLoading = false;
    },
    setTempCustomers(state, action) {
      state.tempCustomers = action.payload;
    },
    setCustomerPagination(state, action) {
      state.pagination = action.payload;
    },
    addCustomer(state, action) {
      state.customers.push(action.payload);
      state.tempCustomers.push(action.payload);
    },
    updateCustomer(state, action) {
      const { index, customer } = action.payload;
      state.customers?.splice(index, 1, customer);
      state.tempCustomers?.splice(index, 1, customer);
    },
    // deleteCustomer(state, action) {
    //   const { index } = action.payload;
    //   state.customers.splice(index, 1);
    //   state.tempCustomers.splice(index, 1);
    // },

    deleteCustomer(state, action) {
  const { index } = action.payload;
  if (index > -1) {
    state.customers.splice(index, 1);
    state.tempCustomers.splice(index, 1);

    // 👇 total ko bhi update karo
    if (state.pagination?.total > 0) {
      state.pagination.total = state.pagination.total - 1;
    }

    // 👇 agar current page last tha aur items khali ho gaye,
    // to page ko ek step peeche le aao
    if (
      state.customers.length === 0 &&
      state.pagination.page > 1
    ) {
      state.pagination.page = state.pagination.page - 1;
    }
  }
},

    setCustomerIsLoading(state, action) {
      state.isLoading = true;
    },
  },
});

export const {
  setCustomers,
  setTempCustomers,
  addCustomer,
  updateCustomer,
  deleteCustomer,
  setCustomerPagination,
  setCustomerIsLoading,
} = customerSlice.actions;
export default customerSlice.reducer;
